// Internal Dependencies
import {
  CHILD_CARE_PROVIDER_EXPANDED_CURRENT_PAGE_SIZE,
  CHILD_CARE_PROVIDER_EXPANDED_DEFAULT_PAGE_SIZE,
  CLIENT_FEATURE_FLAGS,
  LEADS_CONFIRMATION,
} from '@/constants';
import { DaycareProviderProfile } from '@/types/seekerCC';
import { getFeatureFlagValue } from '@/utilities/featureFlagHelper';

// Custom types

export interface daycareLeadFormatted {
  businessName: string;
  phoneNumber: string | null;
  // TODO: This is broken in CZEN. Will fix in CZEN and uncomment.
  // url: string | null;
  address: {
    addressLine1: string;
    city: string;
    state: string;
    zip: string;
  };
}

/**
 * Takes the existing list of daycare providers, and returns it in the
 * format expected by Iterable.
 *
 * @param daycareLeads List of daycare providers.
 * @returns List of daycare providers in the format for Iterable event.
 */
export function convertDaycareLeadsToCrmEventFormat(
  daycareLeads: DaycareProviderProfile[]
): daycareLeadFormatted[] {
  const daycareLeadsFormatted: daycareLeadFormatted[] = [];

  daycareLeads.forEach((daycareLead) => {
    if (daycareLead.selected) {
      const daycareLeadFormatted: daycareLeadFormatted = {
        businessName: daycareLead.name as string,
        phoneNumber: daycareLead.contactDetails?.leadPhone?.number || null,
        // TODO: This is broken in CZEN. Will fix in CZEN and uncomment.
        // url: daycareLead.businessProfileUri || null,
        address: {
          addressLine1: daycareLead.address?.addressLine1 || '',
          city: daycareLead.address?.city || '',
          state: daycareLead.address?.state || '',
          zip: daycareLead.address?.zip || '',
        },
      };

      daycareLeadsFormatted.push(daycareLeadFormatted);
    }
  });

  return daycareLeadsFormatted;
}

export const getRecommendationsCountForDisplay = () => {
  const isShowUpto7RecommendationsEnabled = getFeatureFlagValue(
    CLIENT_FEATURE_FLAGS.DAYCARE_ENROLLMENT_UPDATE_RECOMMENDATIONS_TO_SHOW_UPTO_7
  );
  return isShowUpto7RecommendationsEnabled
    ? CHILD_CARE_PROVIDER_EXPANDED_DEFAULT_PAGE_SIZE
    : CHILD_CARE_PROVIDER_EXPANDED_CURRENT_PAGE_SIZE;
};

const getFormattedDistanceSingularOrPlural = (distance: number) => {
  return distance === 1 ? LEADS_CONFIRMATION.DISTANCE.SINGULAR : LEADS_CONFIRMATION.DISTANCE.PLURAL;
};

export const getFormattedDistanceForDisplay = (distance: { unit: string; value: number }) => {
  const { unit, value } = distance;
  if (unit === LEADS_CONFIRMATION.DISTANCE.UNIT) {
    return `${value} ${getFormattedDistanceSingularOrPlural(value)} away`;
  }
  return `${value} ${unit}`;
};
